import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Form, HStack, Page, Button } from "@towersystems/roam-common-native";
import { LayoutNodeInput } from "@towersystems/roam-common/lib/generated-types";
import { useFormContext } from "react-hook-form";
import { Colors, View } from "react-native-ui-lib";
import { EditProductQuickKeyRootParamList } from "../../../../types";
import { useEditTile } from "../../../../utilities/layout";

import { LayoutNodeProductForm } from "../../components";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";

export type EditProductQuickKeyScreenProps = NativeStackScreenProps<
  EditProductQuickKeyRootParamList,
  "EditProductQuickKeyScreen"
>;

export function EditProductQuickKeyScreen({
  navigation,
}: EditProductQuickKeyScreenProps) {
  const { item, handleUpdateTile, handleRemoveTile } = useEditTile();

  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  const {
    handleSubmit,
    formState: { isDirty, isValid, isSubmitting },
  } = useFormContext<LayoutNodeInput>();

  // this original code is janky and confusing - needs to be refactored properly
  // it does not support updating local values that differ from the server without
  // significant changes to the useEditTile hook.
  // For example uploading an image and updating the image URL locally before saving is not possible
  //
  // After save, reload the tile data from server to ensure consistency
  const updateTile = async (values: LayoutNodeInput) => {
    return handleUpdateTile(values).then(async () => {
      // reload tile data from server here
      await fetchAndSyncEntity("layout_nodes");
    });
  };

  if (!item) {
    return null;
  }

  const footer = isDirty ? (
    <Button
      label={"Save"}
      backgroundColor={Colors.action}
      color="white"
      disabled={!isValid || isSubmitting}
      onPress={handleSubmit(updateTile, console.log)}
    ></Button>
  ) : (
    <HStack>
      <View flex>
        <Button
          style={{ flexGrow: 1 }}
          isDestructive
          onPress={() => handleRemoveTile(item.id)}
          label="Remove Tile"
          disabled={isSubmitting}
        ></Button>
      </View>
      <View flex>
        <Button
          style={{ flexGrow: 1 }}
          onPress={() => navigation.goBack()}
          isAction
          label="Return to Sell Screen"
        ></Button>
      </View>
    </HStack>
  );

  return (
    <Page
      title="Product POS quick key"
      secondaryTitle="Configure the product quick key settings"
      footer={footer}
    >
      <Form>
        <LayoutNodeProductForm item={item.config} />
      </Form>
    </Page>
  );
}
